module.exports = __webpack_public_path__ + "img/loki.97198ad1.svg";